import { Avatar, Card, Flex, Text } from "@chakra-ui/react";
import type { User } from "../types/user.types";

type TUser = Pick<User, "id" | "firstName" | "lastName">;

type AudiosCardProps = {
	author?: TUser;
	responsible?: TUser;
};

const AudioResponsible = (props: Pick<AudiosCardProps, "responsible">) => {
	const { responsible } = props;
	return (
		<Flex direction="column" w="100%" mt={2} gap={2}>
			<Text lineHeight="21px" fontSize="14px" fontWeight="600">
				Audioprothésiste responsable
			</Text>
			<div className="flex flex-row items-center gap-2">
				<Avatar
					name={`${responsible?.firstName} ${responsible?.lastName}`}
					src="https://bit.ly/avatar"
					h="32px"
					w="32px"
				/>
				<Text
					lineHeight="21px"
					fontSize="16px"
					fontWeight="400"
					textTransform="capitalize"
				>
					{responsible?.firstName} {responsible?.lastName}
				</Text>
			</div>
		</Flex>
	);
};

const AudioAuthor = (props: Pick<AudiosCardProps, "author">) => {
	const { author } = props;
	return (
		<Flex direction="column" w="100%" mt={2} gap={2}>
			<Text lineHeight="21px" fontSize="14px" fontWeight="600">
				Créé par
			</Text>
			<div className="flex flex-row items-center gap-2">
				<Avatar
					name={`${author?.firstName} ${author?.lastName}`}
					src="https://bit.ly/avatar"
					h="32px"
					w="32px"
				/>
				<Text
					lineHeight="21px"
					fontSize="16px"
					fontWeight="400"
					textTransform="capitalize"
				>
					{author?.firstName} {author?.lastName}
				</Text>
			</div>
		</Flex>
	);
};

const AudiosCard = (props: AudiosCardProps) => {
	return (
		<Card w="100%">
			<Flex
				borderTopRadius="xl"
				px={4}
				py={2}
				borderBottom="solid 1px"
				borderColor="gray.200"
				w="100%"
				direction="column"
			>
				<Text
					lineHeight="21px"
					fontSize="16px"
					fontWeight="600"
					py={4}
					borderBottom="solid 1px"
					borderColor="gray.200"
				>
					Détails de la commande
				</Text>
				<Flex direction="column" w="100%" mt={2}>
					<AudioResponsible responsible={props.responsible} />
					<AudioAuthor author={props.author} />
				</Flex>
			</Flex>
		</Card>
	);
};

export default AudiosCard;
